module.exports = __webpack_public_path__ + "static/img/4444.179a13b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/app/4444.jpg
// module id = HMix
// module chunks = 1